import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
import { z } from "zod";
import { ensureElementVisible } from "@/lib/route-guards";

const PurchasePriceDeviationsPage = lazy(
	() => import("@/features/reports/purchase-price-deviations-page"),
);

// FARMASTER-FRONTEND-33/34: zły `dateFrom`/`dateTo` w URL (stary bookmark, ręczna
// edycja) rzucał ZodError w validateSearch → crash całej trasy. `.catch(undefined)`
// = traktuj niepoprawny param jak brak, strona ładuje się z domyślnym zakresem.
const isoDate = z
	.string()
	.regex(/^\d{4}-\d{2}-\d{2}$/)
	.optional()
	.catch(undefined);

const searchSchema = z.object({
	scope: z.string().optional(),
	dateFrom: isoDate,
	dateTo: isoDate,
});

export type PurchasePriceDeviationsSearch = z.infer<typeof searchSchema>;

export const Route = createFileRoute("/_auth/raporty/odchylenia-cen-fv")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.raporty.odchylenia-cen-fv",
			location.pathname,
		);
	},
	component: PurchasePriceDeviationsPage,
	validateSearch: (search: Record<string, unknown>): PurchasePriceDeviationsSearch =>
		searchSchema.parse(search),
});
